import { __assign, __read, __spread } from "tslib";
import { URL } from 'url';
import qs from 'query-string-for-all';
export * from './types';
var EXCLUDED_PARAMS = [
    'offset',
    'sort',
    'direction',
    'size',
    'q',
    'utm_source',
    'utm_content',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'ad',
];
var PREFIXES = {
    rangeGroup: 'rg_',
    range: 'r_',
    boolean: 'b_',
};
function unsupportedFilterType(_filter, returnValue) {
    return returnValue;
}
export var filterToQueryParams = function (filter) {
    var _a, _b, _c, _d, _e;
    switch (filter.type) {
        case 'term': {
            return _a = {}, _a[filter.property] = filter.id, _a;
        }
        case 'terms': {
            return _b = {}, _b[filter.property] = filter.ids.join('|'), _b;
        }
        case 'range': {
            return _c = {},
                _c["" + PREFIXES.range + filter.property] = filter.from + "-" + filter.to,
                _c;
        }
        case 'range-group': {
            return _d = {},
                _d["" + PREFIXES.rangeGroup + filter.property] = filter.key,
                _d;
        }
        case 'boolean': {
            var trueValues = ['1', 'true', 'yes', 1, true];
            var value = trueValues.includes(filter.id) ? '1' : '0';
            return _e = {},
                _e["" + PREFIXES.boolean + filter.property] = value,
                _e;
        }
        default:
            return unsupportedFilterType(filter, {});
    }
};
export var getSortedQuery = function (query) {
    return Object.keys(query)
        .sort()
        .reduce(function (result, key) {
        var _a;
        return (__assign(__assign({}, result), (_a = {}, _a[key] = query[key], _a)));
    }, {});
};
export var addFilterToUrl = function (baseUrl, filter) {
    var _a = __read(baseUrl.split('?', 2), 2), baseUrlPathName = _a[0], baseUrlQueryString = _a[1];
    var baseUrlQuery = qs.parse(baseUrlQueryString || '');
    var newQuery = __assign(__assign({}, baseUrlQuery), filterToQueryParams(filter));
    if (Object.keys(newQuery).length === 0) {
        return baseUrlPathName;
    }
    return baseUrlPathName + "?" + qs.stringify(getSortedQuery(newQuery));
};
export var addFilterToUrlBuilder = function (urlBuilder, filter) {
    var filterQueryParams = filterToQueryParams(filter);
    Object.entries(filterQueryParams).forEach(function (_a) {
        var _b = __read(_a, 2), key = _b[0], value = _b[1];
        return urlBuilder.searchParams.set(key, value);
    });
    urlBuilder.searchParams.sort();
};
export var extractFiltersFromUrl = function (url) {
    var searchParams = new URL(url, 'http://dummy').searchParams;
    var params = __spread(searchParams.keys()).filter(function (key) { return !EXCLUDED_PARAMS.includes(key); });
    return params
        .map(function (param) {
        var paramValue = searchParams.get(param);
        if (paramValue === null) {
            return null;
        }
        if (param.startsWith(PREFIXES.rangeGroup)) {
            return {
                type: 'range-group',
                property: param.substr(PREFIXES.rangeGroup.length),
                key: paramValue,
            };
        }
        if (param.startsWith(PREFIXES.range)) {
            var match = paramValue.match(/^(-?\d+\.?\d*)-(-?\d+\.?\d*)$/);
            var from = match && match[1] ? Number.parseFloat(match[1]) : NaN;
            var to = match && match[2] ? Number.parseFloat(match[2]) : NaN;
            return {
                type: 'range',
                property: param.substr(PREFIXES.range.length),
                from: !Number.isNaN(from) ? from : null,
                to: !Number.isNaN(to) ? to : null,
            };
        }
        if (param.startsWith(PREFIXES.boolean)) {
            return {
                type: 'boolean',
                property: param.substr(PREFIXES.boolean.length),
                id: ['1', 'true', 'yes'].includes(paramValue),
            };
        }
        // Values can be divided by | or , which indicates OR AND operators
        var delimiter = paramValue.includes(',') ? ',' : '|';
        var operator = delimiter === ',' ? 'AND' : 'OR';
        var values = paramValue.split(delimiter);
        return values.length === 1
            ? {
                type: 'term',
                property: param,
                id: values[0],
            }
            : {
                type: 'terms',
                property: param,
                ids: values,
                operator: operator,
            };
    })
        .filter(Boolean);
};
var getProductsSlice = function (data) {
    return data.slices.find(function (slice) {
        return slice.type === 'products';
    });
};
var addOffsetToUrlBuilder = function (urlBuilder, data) {
    var productSlice = getProductsSlice(data);
    if (productSlice && productSlice.offset > 0) {
        urlBuilder.searchParams.set('offset', "" + productSlice.offset);
        urlBuilder.searchParams.sort();
    }
    return urlBuilder;
};
export var getUrlFromResponse = function (data, baseUrl, options) {
    if (options === void 0) { options = { includeOffset: true }; }
    var urlBuilder = new URL(data.baseUrl, baseUrl);
    data.filters.forEach(function (filter) { return addFilterToUrlBuilder(urlBuilder, filter); });
    if (options.includeOffset) {
        addOffsetToUrlBuilder(urlBuilder, data);
    }
    return urlBuilder;
};
export var getCanonicalUrlFromResponse = function (data, baseUrl, options) {
    if (options === void 0) { options = { includeOffset: true }; }
    var urlBuilder = new URL(data.baseUrl, baseUrl);
    data.navigationState.previous.forEach(function (_a) {
        var filters = _a.filters;
        return filters.forEach(function (f) { return addFilterToUrlBuilder(urlBuilder, f); });
    });
    if (options.includeOffset) {
        addOffsetToUrlBuilder(urlBuilder, data);
    }
    return urlBuilder;
};
export var getNextUrlFromResponse = function (data, baseUrl) {
    var productSlice = getProductsSlice(data);
    if (!productSlice ||
        productSlice.pagination.currentPage >= productSlice.pagination.pages) {
        return null;
    }
    var pagination = productSlice.pagination, size = productSlice.size;
    var urlBuilder = getCanonicalUrlFromResponse(data, baseUrl, {
        includeOffset: false,
    });
    urlBuilder.searchParams.set('offset', "" + pagination.currentPage * size);
    urlBuilder.searchParams.sort();
    return urlBuilder;
};
export var getPreviousUrlFromResponse = function (data, baseUrl) {
    var productSlice = getProductsSlice(data);
    if (!productSlice || productSlice.pagination.currentPage === 1) {
        return null;
    }
    var offset = productSlice.offset, size = productSlice.size;
    var urlBuilder = getCanonicalUrlFromResponse(data, baseUrl, {
        includeOffset: false,
    });
    var newOffset = offset - size;
    if (newOffset > 0) {
        urlBuilder.searchParams.set('offset', "" + newOffset);
        urlBuilder.searchParams.sort();
    }
    return urlBuilder;
};
//# sourceMappingURL=index.js.map